<template>
  <div class="sw-card">
    <div class="sw-columns">
      <div v-for="(col, idx) in parsedColumns" :key="idx" class="sw-column" :class="col.type">
        <div class="sw-label" :class="col.type">{{ col.title }}</div>
        <div class="sw-desc" v-if="col.description">{{ col.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StrengthsWeaknesses',
  props: {
    columns: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedColumns() {
      if (Array.isArray(this.columns)) return this.columns
      if (typeof this.columns === 'string') {
        try {
          const parsed = JSON.parse(this.columns)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.sw-card {
  padding: 0;
  background: transparent;
  border: none;
}

.sw-columns {
  display: flex;
  gap: 10px;
}

.sw-column {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
}

.sw-label {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.sw-label.strengths {
  color: #2e7d32;
}

.sw-label.weaknesses {
  color: #e65100;
}

.sw-label.neutral {
  color: #1565c0;
}

.sw-desc {
  font-size: 13px;
  color: #374151;
  line-height: 1.7;
}
</style>
